import dayjs from "dayjs";
import clsx from "clsx";
import { DisplayText } from "../DisplayText";
import { SNSShareSection } from "../SNSShareSection";
import type { TopicsResponse } from "@/lib/microcms.server";

interface TopicsArticleProps {
  post: TopicsResponse;
  shareURL: string;
  shareText: string;
}

export function TopicsArticle({ post, shareURL, shareText }: TopicsArticleProps) {
  return (
    <article
      className={clsx("w-full", post.protect_images && "no-image-save")}
      itemScope
      itemType="https://schema.org/Article"
    >
      <header className={clsx("flex", "mb-8", "font-sans", "font-bold", "text-lg", "leading-normal")}>
        <div className="space-y-2 w-full">
          <DisplayText element="h1" itemProp="headline" size="extraLarge">
            {post.title}
          </DisplayText>
          <div className={clsx("flex", "items-center", "flex-wrap", "space-x-4")}>
            <div className="min-w-0 flex-grow">
              <div className={clsx("font-bold", "text-base", "leading-normal", "flex")}>
                <span className={clsx("block", "text-gray-700")}>
                  <time itemProp="datePublished" dateTime={post.publishedAt}>
                    {dayjs(post.publishedAt).locale("ja").format("YYYY/M/D (dd)")}
                  </time>
                </span>
                <span aria-hidden="true" className={clsx("block", "text-gray-700", "mx-2")}>
                  ・
                </span>
                <span
                  itemProp="contentLocation"
                  className={clsx(
                    "block",
                    post.category[0] === "イベントレポート" && "text-brand-green",
                    post.category[0] === "お知らせ" && "text-brand-red"
                  )}
                >
                  <span className="visually-hidden">カテゴリ: </span>
                  {post.category[0]}
                </span>
              </div>
            </div>
            <div className="min-w-0">
              <SNSShareSection url={shareURL} text={shareText} />
            </div>
          </div>
        </div>
      </header>
      <div className="rte" dangerouslySetInnerHTML={{ __html: post.content }} />
    </article>
  );
}
